module.exports = __webpack_public_path__ + "static/img/btn-bg-gray.bd8c0b94.png";